import React from 'react'

import { Return } from 'modules/core/lib/asyncAction'

import type Review from 'modules/reviews/store/models/v2/Review'

export interface ContextProps {
  review: Review
  canbeStarted: boolean
  updateCanBeStarted: () => Promise<Return<void>>
  canEditReview: boolean
  isAnonymous: boolean
}

export const ReviewShowContext = React.createContext<ContextProps | null>(null)

export const useReviewShowContext = () => {
  const context = React.useContext(ReviewShowContext)
  if (!context) {
    throw new Error('ReviewShowContext must be within its provider')
  }
  return context
}
